/**
 * Version tracking service for handling changelog display
 */

import packageJson from '../../package.json';
import { changelogData } from '../components/Popups/ChangelogModal';

const VERSION_STORAGE_KEY = 'meeples_last_seen_version';

export class VersionTracker
{
  /**
   * Get the current app version from package.json
   */
  static getCurrentVersion()
  {
    return packageJson.version;
  }

  /**
   * Get a display-friendly version string (removes trailing .0 for cleaner display)
   */
  static getDisplayVersion()
  {
    const version = VersionTracker.getCurrentVersion();
    // Remove trailing .0 for display (e.g., "0.1.0" becomes "0.1")
    return version.replace( /\.0$/, '' );
  }

  /**
   * Get the last version the user has seen the changelog for
   */
  static getLastSeenVersion()
  {
    try
    {
      return localStorage.getItem( VERSION_STORAGE_KEY );
    } catch( error )
    {
      console.warn( 'Could not read from localStorage:', error );
      return null;
    }
  }

  /**
   * Mark the current version as seen by the user
   */
  static markVersionAsSeen( version = null )
  {
    const versionToMark = version || VersionTracker.getCurrentVersion();
    try
    {
      localStorage.setItem( VERSION_STORAGE_KEY, versionToMark );
    } catch( error )
    {
      console.warn( 'Could not write to localStorage:', error );
    }
  }

  /**
   * Check if the user should see the changelog for the current version
   * @returns {boolean} true if changelog should be shown
   */
  static shouldShowChangelogAutomatically()
  {
    const currentVersion = VersionTracker.getCurrentVersion();
    const lastSeenVersion = VersionTracker.getLastSeenVersion();

    // Show if this is the first time or if the version has changed
    return !lastSeenVersion || lastSeenVersion !== currentVersion;
  }

  /**
   * Check if there are any available changelogs
   */
  static hasChangelogForVersion( version )
  {
    // Automatically detect available versions from changelogData
    return Object.keys( changelogData ).includes( version );
  }

  /**
   * Get all available versions that have changelogs
   */
  static getAvailableVersions()
  {
    return Object.keys( changelogData );
  }
}

export default VersionTracker;
